import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AssetDto, GalleryDto, GalleryTheme } from '@nusign/picflow-backend-types';
import { ApplyTypographyStylesDirective } from '../../../directives/apply-typography-styles.directive';
import { CoverDesignAssetComponent } from '../cover-design-asset/cover-design-asset.component';

@Component({
  selector: 'app-cover-design-frame',
  imports: [CoverDesignAssetComponent, ApplyTypographyStylesDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './cover-design-frame.component.html',
  styleUrl: './cover-design-frame.component.scss',
})
export class CoverDesignFrameComponent {
  theme = input.required<GalleryTheme>();
  gallery = input.required<GalleryDto>();
  previewAsset = input<AssetDto>();
  noAsset = input<boolean>();
  animated = input<boolean>();
}
